module.exports = __webpack_public_path__ + "assets/b261bf37ca494dabfa8b9d3a5c0fa41f.svg";